import React from "react";
import { Helmet } from "react-helmet-async";
import Hero from "../layouts/Slider";
import About from "../layouts/About";
import WhyUs from "../layouts/WhyUs";
import Services from "../layouts/Services";
import FAQ from "../layouts/FAQ";
import Contact from "../layouts/Contact";
import OrderNowPrompt from "../layouts/OrderNowPrompt";
import ValueStrip from "../layouts/ValueStrip";
import ShareSizes from "../layouts/ShareSizes";
import Delivery from "../layouts/Delivery";
import CommunityCTA from "../layouts/CommunityCTA";

const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Farmer Boaz",
  url: "https://farmerboaz.com",
  logo: "https://farmerboaz.com/logo2.png",
  description:
    "Farmer Boaz connects local farmers with the community through farm-fresh produce and meat community shares in Calgary, Alberta.",
  areaServed: "Calgary, Alberta",
  email: "info@farmerboaz.com",
  sameAs: [
    "https://www.instagram.com/farmerboaz",
    "https://www.linkedin.com/company/farmer-boaz",
    "https://discord.gg/X47Vt45XWh",
  ],
};

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Farmer Boaz – Farm-Fresh Community Shares & Local Meat</title>
        <meta
          name="description"
          content="Order fresh, local meat and produce with Farmer Boaz community share campaigns in Calgary. Simple, safe, and sustainable."
        />
        <script type="application/ld+json">{JSON.stringify(ORGANIZATION_SCHEMA)}</script>
      </Helmet>

      <Hero />
      <ValueStrip />
      <OrderNowPrompt />
      <About />
      <WhyUs />
      <ShareSizes />
      <Services />
      <Delivery />
      <FAQ />
      <CommunityCTA />
      <Contact />
    </>
  );
};

export default HomePage;
